<template>
  <div class="header">
    <div class="wrap_inner">
      <h1 class="logo">메리츠화재</h1>
      <h2 class="title" @click="pass">
        <strong>피보험자</strong><span>전자서명</span>
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    type: String,
  },
  setup(props, { emit }) {
    let passCnt = 0

    const pass = () => {
      passCnt++
      if (passCnt >= 5) {
        emit('pass')
      }
    }

    return {
      pass,
    }
  },
}
</script>

<style scoped>
.title {
  position: absolute;
  left: 54px;
  top: 18px;
  /* left: 100px;
  top: 18px; */
}
</style>
